import CityPage from "../CityPage";

export default function WillowSprings() {
  return <CityPage slug="willow-springs" />;
}
